import { useEffect } from "react"

const wheelEditableTypes = new Set(["number", "date", "datetime-local", "time", "month", "week", "range"])

export default function PreventWheelInputChanges() {
  useEffect(() => {
    const handleWheel = event => {
      const field = event.target
      if (field !== document.activeElement || field.disabled || field.readOnly) return

      if ((field instanceof HTMLInputElement && wheelEditableTypes.has(field.type)) ||
          field instanceof HTMLSelectElement) {
        // Blur before native stepping, without cancelling normal page/menu scrolling.
        field.blur()
      }
    }

    // Capture also covers modal portals. Run synchronously before the browser
    // scrolls/steps a control, but leave the event uncancelled so scrolling works.
    const options = { capture: true, passive: false }
    document.addEventListener("wheel", handleWheel, options)
    return () => document.removeEventListener("wheel", handleWheel, options)
  }, [])

  return null
}
